import { Component, ChangeDetectionStrategy, Output, EventEmitter, ElementRef, Input } from '@angular/core';
var AmdOptionComponent = /** @class */ (function () {
    /**
     * @param {?} elementRef
     */
    function AmdOptionComponent(elementRef) {
        this.elementRef = elementRef;
        this.optionClick = new EventEmitter();
    }
    Object.defineProperty(AmdOptionComponent.prototype, "content", {
        /**
         * @return {?}
         */
        get: function () {
            return (this.nativeElement.textContent || '').trim(); // [TODO] - remove direct DOM acces
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AmdOptionComponent.prototype, "nativeElement", {
        /**
         * @return {?}
         */
        get: function () {
            return this.elementRef.nativeElement;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AmdOptionComponent.prototype.onClick = function () {
        this.optionClick.emit();
    };
    AmdOptionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-option',
                    template: "<div class=\"amd-option amd-menu__item\" (click)=\"onClick()\"> <ng-content></ng-content> </div>",
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdOptionComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    AmdOptionComponent.propDecorators = {
        'optionClick': [{ type: Output },],
        'value': [{ type: Input },],
    };
    return AmdOptionComponent;
}());
export { AmdOptionComponent };
function AmdOptionComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdOptionComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdOptionComponent.ctorParameters;
    /** @type {?} */
    AmdOptionComponent.propDecorators;
    /** @type {?} */
    AmdOptionComponent.prototype.optionClick;
    /** @type {?} */
    AmdOptionComponent.prototype.value;
    /** @type {?} */
    AmdOptionComponent.prototype.elementRef;
}
//# sourceMappingURL=option.component.js.map
//# sourceMappingURL=option.component.js.map
